import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c77af954"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  id: "vue",
  style: {
    "padding": "10px"
  }
};
const _hoisted_3 = {
  class: "info"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "0"
}, "波色", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "1"
}, "五行", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "2"
}, "生肖", -1));
const _hoisted_7 = [_hoisted_4, _hoisted_5, _hoisted_6];
const _hoisted_8 = ["input"];
const _hoisted_9 = {
  class: "wheel-wrapper"
};
const _hoisted_10 = {
  class: "prize-list"
};
const _hoisted_11 = {
  class: "prize-name"
};
const _hoisted_12 = {
  key: 0,
  class: "info",
  style: {
    "color": "#000"
  }
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, [_createTextVNode(" 选择转盘类型： "), _withDirectives(_createElementVNode("select", {
    style: {
      "padding": "2px",
      "font-size": "16px"
    },
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.kind = $event),
    onChange: _cache[1] || (_cache[1] = $event => {
      $data.rolTime = 0;
      $data.wheelDeg = 0;
    })
  }, _hoisted_7, 544), [[_vModelSelect, $data.kind]])]), _createElementVNode("p", null, [_createTextVNode(" 设置转动速度："), _withDirectives(_createElementVNode("input", {
    style: {
      "width": "90px"
    },
    type: "range",
    min: "2",
    max: "14",
    step: "6",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.setTime = $event),
    input: $options.setRol()
  }, null, 8, _hoisted_8), [[_vModelText, $data.setTime]]), _createTextVNode(" " + _toDisplayString($data.rolStr), 1)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: "wheel-pointer",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.onClickRotate && $options.onClickRotate(...args))
  }, "开始"), _createElementVNode("div", {
    class: _normalizeClass(["wheel-bg", `bg` + $data.kind]),
    style: _normalizeStyle(`transform: rotate(${$data.wheelDeg}deg);transition-duration:${$data.rolTime}s`)
  }, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.zhuanList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "prize-item-wrapper",
      key: index
    }, [_createElementVNode("div", {
      class: "prize-item",
      style: _normalizeStyle(`transform: rotate(${360 / $options.zhuanList.length * index}deg)`)
    }, [_createElementVNode("div", _hoisted_11, _toDisplayString(item), 1)], 4)]);
  }), 128))])], 6)]), $data.bs || $data.wx || $data.sx ? (_openBlock(), _createElementBlock("div", _hoisted_12, [$data.bs ? (_openBlock(), _createElementBlock("p", _hoisted_13, "波色：" + _toDisplayString($data.bs), 1)) : _createCommentVNode("", true), $data.wx ? (_openBlock(), _createElementBlock("p", _hoisted_14, "五行：" + _toDisplayString($data.wx), 1)) : _createCommentVNode("", true), $data.sx ? (_openBlock(), _createElementBlock("p", _hoisted_15, "生肖：" + _toDisplayString($data.sx), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]);
}